import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { openDialer } from "../../data/redux/slices/FloatingDialerSlice";
import FloatingDialer from "../floating-dialer/FloatingDialer";

export default function Dialer() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openDialer());
  }, [dispatch]);

  return <FloatingDialer />;
}
